import axios from "axios";
const selfAxios = axios.create();
export { selfAxios };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/axios/selfAxios.js